// Styles
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
// Constants
import { ResponsiveHeaderWidths } from "@ms/planner-generic-controls/lib/local/constants/StyleConstants";
// Utilities
import { flexChildSizeFixed, flexParent, flexParentCenterCrossAxis, textClip } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * Styles for PlanHeaderInfo
 */ export const usePlanHeaderInfoStyles = makeStyles({
    root: {
        ...flexChildSizeFixed(),
        ...flexParent("row", "nowrap"),
        ...flexParentCenterCrossAxis,
        gap: "8px",
        minWidth: 0
    },
    breadcrumb: {
        ...flexParent(),
        ...textClip("ellipsis"),
        alignItems: "center",
        margin: "0px",
        minWidth: "150px",
        "@media (max-width: 677px)": {
            minWidth: "120px"
        }
    },
    breadcrumbItem: {
        padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalXXS}`
    },
    breadcrumbButton: {
        fontSize: tokens.fontSizeBase400,
        borderRadius: tokens.borderRadiusXLarge,
        padding: tokens.spacingHorizontalS,
        ...shorthands.borderColor("transparent"),
        "&:focus-visible, &[data-fui-focus-visible]": {
            outline: `${tokens.strokeWidthThick} solid ${tokens.colorStrokeFocus2}`,
            outlineOffset: `calc(${tokens.strokeWidthThick} * -1)`
        }
    },
    // "My Plans" breadcrumb label collapses to icon-only on a narrow header via the `pageHeader` container query, freeing space for the plan title.
    myPlansBreadcrumbText: {
        [`@container pageHeader (max-width: ${ResponsiveHeaderWidths.maxWidth640}px)`]: {
            display: "none"
        }
    },
    breadcrumbDivider: {
        color: tokens.colorNeutralForeground1,
        fontSize: tokens.fontSizeBase500,
        flexShrink: 0
    },
    breadcrumbList: {
        ...textClip("ellipsis")
    },
    planAvatar: {
        ...flexParent(),
        marginRight: tokens.spacingHorizontalS
    },
    planTitle: {
        ...flexParent(),
        ...textClip("ellipsis"),
        fontWeight: tokens.fontWeightBold,
        width: "100%",
        minWidth: 0,
        justifyContent: "flex-start",
        maxWidth: "300px",
        paddingLeft: tokens.spacingHorizontalM
    },
    planTitleContainer: {
        ...textClip("ellipsis"),
        minWidth: "32px"
    },
    planTitleText: {
        ...textClip("ellipsis"),
        minWidth: 0,
        flex: "1 1 0",
        textAlign: "left",
        fontSize: tokens.fontSizeBase400
    },
    pinButton: {
        height: "24px",
        minWidth: "24px",
        maxWidth: "24px",
        color: tokens.colorNeutralForeground1,
        flexShrink: 0
    },
    titleSideTag: {
        backgroundColor: tokens.colorNeutralBackground4,
        height: "24px",
        flexShrink: 0
    },
    titleSideTagText: {
        fontSize: tokens.fontSizeBase200
    },
    delinkIcon: {
        display: "flex",
        flexShrink: 0
    },
    divider: {
        color: tokens.colorNeutralStrokeSubtle
    },
    dismiss: {
        color: tokens.colorStatusDangerForeground3
    }
});
